import PrivacyPolicyContent from "@/modal-contents/privacy-policy-content";
import KvkkContent from "@/modal-contents/kvkk-contents";
import ExplicitConsent from "@/modal-contents/explicit-consent";

const SIGNUP_CONTRACT = "SIGNUP_CONTRACT";
const KVKK = "KVKK";
const EXPLICIT_CONSENT = "EXPLICIT_CONSENT";

export const modalCases = [SIGNUP_CONTRACT, KVKK, EXPLICIT_CONSENT];

export const modalContents = {
  SIGNUP_CONTRACT: <PrivacyPolicyContent />,
  KVKK: <KvkkContent />,
  EXPLICIT_CONSENT: <ExplicitConsent />,
};

export const renderContent = (name) => {
  const isCase = modalCases.includes(name);

  if (!isCase) return;

  return modalContents[name];
};
